// extracted by mini-css-extract-plugin
module.exports = {"wrap":"src-components-layout-content-__index__wrap--3FdBv"};